import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../Redux/store";
import { Todo } from "../../../Types/Todo";

const baseUrl = 'https://customer.hirsch.com/account/v2/employee/actionitems';

interface TodoArgs {
    writerId?: string | null;
}

export const getTodo = createAsyncThunk<Todo[], TodoArgs, {state: RootState}> (
    'todo/getTodo',
    async(args,{ getState, rejectWithValue }) => {
        try {
            const params = new URLSearchParams();
            const token = getState().auth.token;

            if (args?.writerId) params.append('writerId', args.writerId);

            if (!token) {
                throw new Error('No Auth Token Found');
            }

            const response = await fetch(`${baseUrl}?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                }
            })

            if(!response.ok) throw new Error('Failed to fetch');
            const json = await response.json();
            console.log('TODO:', json)

            return json;
        } catch (err: any) {
            return rejectWithValue(err.message);
        } 
    }
)

interface TodoState {
    todoArr: Todo[];
    loading: boolean;
    error: string | boolean | null | undefined;
}

const initialState: TodoState = {
    todoArr: [],
    loading: false,
    error: null,
}

const todoSlice = createSlice({
    name: 'todo',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getTodo.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getTodo.fulfilled, (state, action) => {
            state.loading = false;
            state.todoArr = action.payload
            state.error = false;
        })
        .addCase(getTodo.rejected, (state, action) => {
            state.loading = false
            state.error = action.error ? action.error.message : 'Failed to Fetch';
        })
    }
})

export const todoReducer = todoSlice.reducer;

export const getTodoList = (state: RootState) => {
    return state.todo.todoArr;
};